import SiHaDocumentationListResourcePagingResultModel from '../../generated/types/model/resource/SiHaDocumentationListResourcePagingResultModel';

export default class SiHaDocumentationListResourcePagingResultViewModel extends SiHaDocumentationListResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
